(() => {
    const inject = [
      '$sce',
    ];

    angular
      .module('app.components')
      .directive('campaignSourceFor', [...inject, (
        $sce,
      ) => ({
        restrict: 'A',
        replace: true,
        transclude: true,
        scope: {
          sourceFor: '=',
          plain: '=',
        },
        controller: ['$scope', ($scope) => {
          $scope.active = false;
          $scope.fadeout = false;
          $scope.onMouseOver = () => {
            $scope.active = true;
            $scope.fadeout = false;
          };
          $scope.onMouseLeave = () => {
            $scope.fadeout = true;
            $scope.active = false;
          };

          $scope.sourceFor = $scope.sourceFor || [];

        }],
        templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/tooltip/campaignSourceFor.html')
      })
    ]);
  })();
